module.exports = __webpack_public_path__ + "static/media/fh.3654ae86.svg";